import type { CmdHistory } from '../CmdHistory.ts'

export function createCmdHistory(): CmdHistory {
	return {
		a: null,
		b: null,
	}
}
